/**
 * Featured collections — tab switcher
 */
class AdawatFeaturedCollections extends HTMLElement {
  connectedCallback() {
    if (this._adawatBooted) return;
    const boot = () => this.boot();
    if (window.AdawatLazyInit?.whenVisible) {
      window.AdawatLazyInit.whenVisible(this, boot);
    } else {
      boot();
    }
  }

  boot() {
    if (this._adawatBooted) return;
    this._adawatBooted = true;

    this.tabs = Array.from(this.querySelectorAll('[data-fc-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-fc-panel]'));
    this.covers = Array.from(this.querySelectorAll('[data-fc-cover]'));
    if (!this.tabs.length) return;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(Number(tab.dataset.fcIndex)));
      tab.addEventListener('keydown', (event) => this.onKeydown(event));
    });
  }

  onKeydown(event) {
    const current = Number(event.currentTarget.dataset.fcIndex);
    let next = null;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      next = (current + 1) % this.tabs.length;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      next = (current - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      next = 0;
    } else if (event.key === 'End') {
      next = this.tabs.length - 1;
    }

    if (next == null) return;
    event.preventDefault();
    this.activate(next);
    this.tabs[next]?.focus();
  }

  activate(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });

    this.panels.forEach((panel, i) => {
      const active = i === index;
      panel.classList.toggle('is-active', active);
      if (active) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    this.covers.forEach((cover, i) => {
      const active = i === index;
      cover.classList.toggle('is-active', active);
      if (active) {
        cover.removeAttribute('hidden');
      } else {
        cover.setAttribute('hidden', '');
      }
    });
  }
}

if (!customElements.get('adawat-featured-collections')) {
  customElements.define('adawat-featured-collections', AdawatFeaturedCollections);
}
